import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyTimesheetDateComponent } from "my-timesheet/components";

type RequestType = {
  rawDate?: string;
  startTime?: string;
  rawEndDate?: string;
  endTime?: string;
  duration?: string | number;
};

interface MyTimesheetShowRequestDialogTimeDataProps {
  request: RequestType;
  width?: string | number;
  isMobile?: boolean;
}

export const MyTimesheetShowRequestDialogTimeData = ({
  request,
  width,
  isMobile,
}: MyTimesheetShowRequestDialogTimeDataProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      justifyContent="space-between"
    >
      <Box
        style={{
          width: isMobile ? "auto" : width ? width : "352px",
        }}
      >
        <MyTimesheetDateComponent
          label={t("OC_START_TIME")}
          date={request?.rawDate}
          time={request?.startTime}
          hideContent={request?.endTime === "Invalid date"}
          width={typeof width === "number" ? `${width}px` : width}
          isMobile={isMobile}
        />
        <Box height="16px" />
        <MyTimesheetDateComponent
          label={t("OC_END_TIME")}
          date={request?.rawEndDate}
          time={request?.endTime}
          hideContent={request?.endTime === "Invalid date"}
          width={typeof width === "number" ? `${width}px` : width}
          isMobile={isMobile}
        />
      </Box>
      {isMobile && <Box height="16px" />}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="168px"
        height="184px"
        padding="16px 16px 0px 16px"
        style={{
          backgroundColor: theme.palette.gray30.main,
          borderRadius: "4px",
        }}
      >
        <Typography
          variant="h2"
          color="primary"
          style={{ fontWeight: "400", color: theme.palette.primary.main }}
        >
          {request?.duration}
        </Typography>
        <Box height="36px" />
        <Typography
          variant="body1"
          style={{
            color: theme.palette.owGray.main,
          }}
        >
          {t("MY_TIME_WORKING_TIME")}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyTimesheetShowRequestDialogTimeData;
